/*
  Beacon "Grid to Full Preview".
  Behaviour follows the Codrops demo by Gwen Bogaert (MIT licence):
  https://tympanus.net/Tutorials/GridToFullPreview/  (https://github.com/gwen-bo/codrops-grid-to-preview)
  Rebuilt with the Web Animations API instead of GSAP. Timings and easing match the original:
  0.5s, power2.inOut, hover intent 100ms, cross-shaped mask over gutters five viewport-widths wide.
*/
(function () {
  'use strict';

  var EASE = 'cubic-bezier(0.645, 0.045, 0.355, 1)'; // GSAP power2.inOut
  var DURATION = 500;
  var HOVER_DELAY = 100;
  var GALLERY_MS = 700;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 900px) and (hover: hover)');

  function Side(container, tiles) {
    this.container = container;
    this.tiles = tiles; // the four tiles this preview replaces, in DOM order
    this.cover = container.querySelector('.gp__cover');
    this.nameEl = container.querySelector('.gp__dname');
    this.priceEl = container.querySelector('.gp__dprice');
    this.images = Array.prototype.slice.call(container.querySelectorAll('.gp__images > img'));
    this.anims = [];
    this.open = false;
    this.timer = null;
    this.build();
  }

  Side.prototype.build = function () {
    var self = this;
    this.anims.forEach(function (a) { a.cancel(); });
    this.anims = [];
    var rect = this.container.getBoundingClientRect();
    var vw = window.innerWidth / 100;
    var arm = 5 * vw;
    var x = (arm / rect.width) * 100;
    var y = (arm / rect.height) * 100;
    var shrink = 5;
    var sx = (rect.width / vw - shrink) / (rect.width / vw);
    var sy = (rect.height / vw - shrink) / (rect.height / vw);
    var dur = reduce ? 1 : DURATION;
    var opts = { duration: dur, easing: EASE, fill: 'both' };

    function cross(a, b) {
      return 'polygon(' + [
        (50 - a / 2) + '% 0%', (50 + a / 2) + '% 0%', (50 + a / 2) + '% ' + (50 - b / 2) + '%', '100% ' + (50 - b / 2) + '%',
        '100% ' + (50 + b / 2) + '%', (50 + a / 2) + '% ' + (50 + b / 2) + '%', (50 + a / 2) + '% 100%', (50 - a / 2) + '% 100%',
        (50 - a / 2) + '% ' + (50 + b / 2) + '%', '0% ' + (50 + b / 2) + '%', '0% ' + (50 - b / 2) + '%', (50 - a / 2) + '% ' + (50 - b / 2) + '%'
      ].join(', ') + ')';
    }
    var closed = 'polygon(50% 0%, 50% 0%, 50% 50%, 100% 50%, 100% 50%, 50% 50%, 50% 100%, 50% 100%, 50% 50%, 0% 50%, 0% 50%, 50% 50%)';

    this.anims.push(this.container.animate([
      { opacity: 0, transform: 'scale(1, 1)' },
      { opacity: 1, transform: 'scale(' + sx + ', ' + sy + ')' }
    ], Object.assign({}, opts)));
    this.anims.push(this.cover.animate([{ clipPath: cross(x, y) }, { clipPath: closed }], Object.assign({}, opts)));
    this.tiles.forEach(function (tile, i) {
      var dx = i % 2 === 0 ? 2.5 : -2.5;
      var dy = i < 2 ? 2.5 : -2.5;
      self.anims.push(tile.animate([
        { opacity: 1, transform: 'translate(0, 0)' },
        { opacity: 0, transform: 'translate(' + dx + 'vw, ' + dy + 'vw)' }
      ], Object.assign({}, opts)));
    });
    this.anims.forEach(function (a) { a.pause(); a.currentTime = 0; });
    this.open = false;
  };

  Side.prototype.stopGallery = function () {
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
  };

  Side.prototype.startGallery = function (id) {
    var self = this;
    this.stopGallery();
    var list = this.images.filter(function (img) { return img.getAttribute('data-id') === id; });
    if (list.length < 2 || reduce) return;
    var n = 0;
    this.timer = setInterval(function () {
      n = (n + 1) % list.length;
      self.images.forEach(function (img) { img.style.opacity = '0'; });
      list[n].style.opacity = '1';
    }, GALLERY_MS);
  };

  Side.prototype.show = function (tile) {
    var id = tile.getAttribute('data-index');
    this.nameEl.textContent = tile.getAttribute('data-name');
    this.priceEl.textContent = tile.getAttribute('data-price');
    this.images.forEach(function (img) { img.style.opacity = '0'; });
    var first = this.images.filter(function (img) { return img.getAttribute('data-id') === id; })[0];
    if (first) first.style.opacity = '1';
    this.stopGallery();
    var self = this;
    this.open = true;
    this.anims.forEach(function (a) { a.playbackRate = 1; a.play(); });
    if (this.anims[0]) {
      this.anims[0].finished.then(function () { if (self.open) self.startGallery(id); }, function () {});
    }
  };

  Side.prototype.hide = function () {
    if (!this.open) return;
    this.open = false;
    this.stopGallery();
    this.anims.forEach(function (a) { a.playbackRate = -1; a.play(); });
  };

  function init(root) {
    var tiles = Array.prototype.slice.call(root.querySelectorAll('.gp__tile'));
    var left = root.querySelector('.gp__preview--left');
    var right = root.querySelector('.gp__preview--right');
    if (!tiles.length || !left || !right) return;

    function half(isLeft) {
      return tiles.filter(function (_, i) { var c = i % 4; return isLeft ? c < 2 : c >= 2; });
    }
    var sides = null;
    function make() {
      // Hovering a tile in the left half opens the RIGHT preview (columns 3-4) and fades the right-half tiles.
      sides = {
        fromLeft: new Side(right, half(false)),
        fromRight: new Side(left, half(true))
      };
    }
    make();

    var active = null, activeSide = null, delay = null;
    function sideFor(tile) {
      var c = tiles.indexOf(tile) % 4;
      return c < 2 ? sides.fromLeft : sides.fromRight;
    }
    function enter(tile) {
      if (delay) { clearTimeout(delay); delay = null; }
      delay = setTimeout(function () {
        active = tile; activeSide = sideFor(tile); activeSide.show(tile); delay = null;
      }, HOVER_DELAY);
    }
    function leave() {
      if (delay) { clearTimeout(delay); delay = null; }
      if (active && activeSide) { activeSide.hide(); active = null; activeSide = null; }
    }

    tiles.forEach(function (tile) {
      tile.addEventListener('mouseenter', function () { enter(tile); });
      tile.addEventListener('mouseleave', leave);
      tile.addEventListener('focusin', function () { enter(tile); });
      tile.addEventListener('focusout', leave);
    });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { leave(); if (desktop.matches) { sides.fromLeft.build(); sides.fromRight.build(); } }, 150);
    });
  }

  /*
    Tap to expand: where the desktop animation is off (narrow windows, touch screens) a tap on a tile
    opens a full-screen white sheet instead of navigating. The tile's own photo grows from the tile's
    rectangle to its place in the sheet (FLIP: measure both rectangles, animate the transform between
    them) and shrinks back into the tile on close. The sheet's photo takes the tile photo's aspect
    ratio, so the framing is identical at both ends. The condition is read at tap time, so resizing
    or rotating works; while the desktop animation is on, clicks keep their normal behaviour.
  */
  var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)'); // read live, at tap time
  var sheet = null;      // one sheet for the page, built on the first tap
  var state = 'closed';  // closed | opening | open | closing
  var cur = null;        // what is open right now

  function make(tag, cls) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    return node;
  }

  function buildSheet() {
    Array.prototype.forEach.call(document.querySelectorAll('body > .gps'), function (old) { old.parentNode.removeChild(old); });
    var root = make('div', 'gps');
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');

    var close = make('button', 'gps__close');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '<svg viewBox="0 0 44 44" width="44" height="44" aria-hidden="true" focusable="false"><path d="M15 15L29 29M29 15L15 29" fill="none" stroke="currentColor" stroke-width="1"/></svg>';

    var bg = make('div', 'gps__bg');
    var col = make('div', 'gps__col');
    var media = make('div', 'gps__media');
    var info = make('div', 'gps__info');
    var details = make('div', 'gps__details');
    var nameEl = make('p', 'gps__name');
    var priceEl = make('p', 'gps__price');
    var view = make('a', 'gps__view');
    view.textContent = 'View';
    view.hidden = true;

    details.appendChild(nameEl);
    details.appendChild(priceEl);
    info.appendChild(details);
    info.appendChild(view);
    col.appendChild(media);
    col.appendChild(info);
    root.appendChild(close);
    root.appendChild(bg);
    root.appendChild(col);
    document.body.appendChild(root);

    sheet = { root: root, close: close, bg: bg, col: col, media: media, info: info, nameEl: nameEl, priceEl: priceEl, view: view, timer: null, fallback: null };

    close.addEventListener('click', function () { closeSheet(); });
    root.addEventListener('click', function (e) {
      // the photo and the empty sheet close it; the close button, the details and the View link do their own thing
      if (e.target.closest && e.target.closest('.gps__close, .gps__view, .gps__details')) return;
      if (state === 'open') closeSheet();
    });
    document.addEventListener('keydown', function (e) {
      if (state === 'closed') return;
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closeSheet(); return; }
      if (e.key !== 'Tab') return;
      var stops = sheet.view.hidden ? [sheet.close] : [sheet.close, sheet.view];
      var first = stops[0], last = stops[stops.length - 1], at = document.activeElement;
      if (!sheet.root.contains(at)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && at === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && at === last) { e.preventDefault(); first.focus(); }
    });
    window.addEventListener('resize', function () { if (state !== 'closed' && desktop.matches) closeNow(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) closeNow(); }); // back from the product page via the cache
  }

  function stopCycle() {
    if (sheet && sheet.timer) { clearInterval(sheet.timer); sheet.timer = null; }
  }

  function startCycle() {
    stopCycle();
    var imgs = Array.prototype.slice.call(sheet.media.querySelectorAll('img'));
    if (imgs.length < 2 || reduceMq.matches) return;
    var n = 0;
    sheet.timer = setInterval(function () {
      var pick = n;
      for (var k = 1; k <= imgs.length; k++) { // hard cut to the next photo that has loaded
        var c = (n + k) % imgs.length;
        if (imgs[c].complete && imgs[c].naturalWidth) { pick = c; break; }
      }
      if (pick === n) return;
      n = pick;
      imgs.forEach(function (im) { im.style.opacity = '0'; });
      imgs[n].style.opacity = '1';
    }, GALLERY_MS);
  }

  // Transform that puts the sheet's photo exactly over the tile's photo.
  function liftFrame() {
    var c = sheet.col.getBoundingClientRect();
    var to = { left: c.left, top: c.top, width: c.width, height: c.width / cur.ratio };
    var from = cur.photo.getBoundingClientRect();
    if (!to.width || !from.width || !from.height) return null;
    var dx = (from.left + from.width / 2) - (to.left + to.width / 2);
    var dy = (from.top + from.height / 2) - (to.top + to.height / 2);
    return 'translate(' + dx + 'px, ' + dy + 'px) scale(' + (from.width / to.width) + ', ' + (from.height / to.height) + ')';
  }

  function openSheet(gp, tile) {
    if (state !== 'closed') return;
    if (!sheet) buildSheet();
    var id = tile.getAttribute('data-index');
    var link = tile.querySelector('a.gp__link');
    var opener = tile.querySelector('.gp__link');
    var tileImg = tile.querySelector('.gp__img');
    var photo = tileImg || opener;
    var box = photo.getBoundingClientRect();
    var ratio = box.width && box.height ? box.width / box.height : 1;

    // The tile's photos live in the hidden preview containers (lazy images there never load), so the
    // sheet builds its own <img> elements from the same addresses and they load on demand.
    var urls = [], crop = '';
    Array.prototype.forEach.call(gp.querySelectorAll('.gp__images > img'), function (img) {
      if (img.getAttribute('data-id') !== id) return;
      if (!urls.length) crop = img.style.objectPosition;
      urls.push(img.getAttribute('src'));
    });
    var held = tileImg ? (tileImg.currentSrc || tileImg.src) : ''; // already on screen, so it paints at once
    if (!urls.length && held) urls.push(held);
    if (!crop && tileImg) crop = tileImg.style.objectPosition;

    sheet.media.textContent = '';
    var first = null;
    urls.forEach(function (u, i) {
      var im = make('img');
      im.alt = i === 0 && tileImg ? tileImg.alt : '';
      im.src = i === 0 && held ? held : u;
      im.style.opacity = i === 0 ? '1' : '0';
      if (i === 0) { if (crop) im.style.objectPosition = crop; first = im; }
      sheet.media.appendChild(im);
    });
    if (first && held && urls[0] !== held) { // swap in the larger file once it has arrived
      var big = new Image();
      big.onload = function () { first.src = urls[0]; };
      big.src = urls[0];
    }

    var name = tile.getAttribute('data-name') || '';
    sheet.nameEl.textContent = name;
    sheet.priceEl.textContent = tile.getAttribute('data-price') || '';
    sheet.root.setAttribute('aria-label', name);
    if (link) { sheet.view.setAttribute('href', link.getAttribute('href')); sheet.view.hidden = false; }
    else { sheet.view.removeAttribute('href'); sheet.view.hidden = true; }
    sheet.col.style.setProperty('--gps-r', String(ratio));

    var wrapper = document.querySelector('.page-wrapper');
    cur = { tile: tile, opener: opener, tileImg: tileImg, photo: photo, ratio: ratio, y: window.pageYOffset, wrapY: wrapper ? wrapper.scrollTop : 0, anims: [] };
    state = 'opening';
    document.documentElement.classList.add('gps-lock');
    sheet.root.setAttribute('data-open', '');

    var dur = reduceMq.matches ? 1 : DURATION;
    var lift = tileImg ? liftFrame() : null;
    var full = { duration: dur, easing: EASE, fill: 'both' };
    var late = { duration: reduceMq.matches ? 1 : DURATION / 2, delay: reduceMq.matches ? 0 : DURATION / 2, easing: EASE, fill: 'both' };
    var photoAnim = sheet.media.animate(lift
      ? [{ transform: lift }, { transform: 'translate(0px, 0px) scale(1, 1)' }]
      : [{ opacity: 0 }, { opacity: 1 }], full);
    cur.anims.push(photoAnim);
    cur.anims.push(sheet.bg.animate([{ opacity: 0 }, { opacity: 1 }], full));
    cur.anims.push(sheet.info.animate([{ opacity: 0 }, { opacity: 1 }], late));
    cur.anims.push(sheet.close.animate([{ opacity: 0 }, { opacity: 1 }], late));
    if (lift) tileImg.style.visibility = 'hidden'; // the sheet's photo stands in for it while it travels

    photoAnim.onfinish = function () {
      if (state === 'opening') { state = 'open'; startCycle(); }
      else if (state === 'closing') finishClose();
    };
    sheet.close.focus({ preventScroll: true });
  }

  function closeSheet() {
    if (state !== 'opening' && state !== 'open') return;
    state = 'closing';
    stopCycle();
    var lift = cur.tileImg ? liftFrame() : null;
    var t = cur.anims[0].currentTime;
    if (t === null || t <= 0) { finishClose(); return; } // nothing has moved yet
    if (lift && cur.anims[0].effect && cur.anims[0].effect.setKeyframes) { // the tile may have moved (rotation, resize)
      cur.anims[0].effect.setKeyframes([{ transform: lift }, { transform: 'translate(0px, 0px) scale(1, 1)' }]);
    }
    cur.anims.forEach(function (a) { a.playbackRate = -1; a.play(); });
    sheet.fallback = setTimeout(finishClose, (reduceMq.matches ? 1 : DURATION) + 400); // never leave the sheet stuck
  }

  function finishClose() {
    if (state !== 'closing' || !cur) return;
    clearTimeout(sheet.fallback);
    sheet.fallback = null;
    cur.anims.forEach(function (a) { a.onfinish = null; a.cancel(); });
    sheet.root.removeAttribute('data-open');
    sheet.media.textContent = '';
    if (cur.tileImg) cur.tileImg.style.visibility = '';
    document.documentElement.classList.remove('gps-lock');
    var wrapper = document.querySelector('.page-wrapper');
    if (window.pageYOffset !== cur.y) window.scrollTo({ top: cur.y, left: 0, behavior: 'instant' });
    if (wrapper && wrapper.scrollTop !== cur.wrapY) wrapper.scrollTo({ top: cur.wrapY, left: 0, behavior: 'instant' });
    var opener = cur.opener;
    cur = null;
    state = 'closed';
    if (opener && opener.focus) opener.focus({ preventScroll: true });
  }

  function closeNow() { // leave without animating: window grew to desktop, or the page came back from the cache
    if (state === 'closed' || !cur) return;
    stopCycle();
    state = 'closing';
    finishClose();
  }

  function initSheet(gp) {
    Array.prototype.forEach.call(gp.querySelectorAll('.gp__tile'), function (tile) {
      var link = tile.querySelector('.gp__link');
      if (!link) return;
      link.addEventListener('click', function (e) {
        if (desktop.matches) return; // desktop keeps its normal navigation
        if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        openSheet(gp, tile);
      });
      link.addEventListener('keydown', function (e) { // an unlinked tile is a focusable div: Enter and Space open it
        if (link.tagName === 'A' || desktop.matches || e.target !== link) return;
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openSheet(gp, tile); }
      });
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-gp]');
    Array.prototype.forEach.call(roots, initSheet);
    if (!desktop.matches) return; // small screens and touch: plain grid of links
    Array.prototype.forEach.call(roots, init);
  }

  if (!('animate' in Element.prototype)) return;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
